mainApp.component('socketIllustration', {
    templateUrl: '/public/components/socket-illustration.component.html',
    bindings: {
        socketConfiguration: '<',
        eventListener: '&',
        selectedConnection: '<',
        hoveredConnection: '<'
    },
    controller: socketIllustrationController
});

function socketIllustrationController($scope) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes['socketConfiguration'] && changes['socketConfiguration'].currentValue)
            ctrl.linksByPosition = _.groupBy(changes['socketConfiguration'].currentValue.links, 'metadata.physicalPosition');
    }

    ctrl.triggerEvent = function(eventType, id) {
        ctrl.eventListener({type: eventType, linkId: id})
    }

    ctrl.getConnectionStyle = function(connection) {
        if (connection.interface_id === ctrl.selectedConnection)
            return "selected";
        return '';
    }

    ctrl.getLabelStyle = function(connection) {
        if (connection.interface_id === ctrl.selectedConnection)
            return "selected";
        if (connection.interface_id === ctrl.hoveredConnection)
            return "hover";
        return '';
    }
};

